export const LOGIN_ROUTE = '/login';
export const REGISTER_ROUTE = '/register';
